import { SocketEventRequestType, SocketEventDirection } from './interfacesOld';
import { socket } from './Socket';
import { log } from './Debug';

export interface IRecord {
  startRecording: () => Promise<void>;
  stopRecording: () => void;
}

let audioContext: any;
let audioInput: any;
let processor: any;

export const useMicRecord = (): IRecord => {
  const startRecording = async () => {
    log('start recording audio');

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      log('microphone access granted');
      audioContext = new AudioContext();
      audioInput = audioContext.createMediaStreamSource(stream);
      processor = audioContext.createScriptProcessor(1024, 1, 1);
      audioInput.connect(processor);
      processor.connect(audioContext.destination);

      processor.onaudioprocess = (e: any) => {
        const float32Array = e.inputBuffer.getChannelData(0);
        const int16Array = new Int16Array(float32Array.length);

        for (let i = 0; i < float32Array.length; i++) {
          int16Array[i] = Math.max(
            -32768,
            Math.min(32767, Math.floor(float32Array[i] * 32768)),
          );
        }
        log(
          'sending audio chunk to server, size',
          int16Array.buffer.byteLength,
        );
        socket.emit(SocketEventDirection.request, {
          type: SocketEventRequestType.transcribeAudio,
          data: { audio: int16Array.buffer },
        });
      };

      socket.emit(SocketEventDirection.request, {
        type: SocketEventRequestType.startTranscription,
        data: { isTranscribeOnly: false },
      });
      log('startTranscription event emitted');
    } catch (error) {
      log('error accessing microphone', error);
    }
  };

  function stopRecording() {
    log('stop recording audio');

    if (audioContext && audioContext.state !== 'closed') {
      try {
        audioInput.disconnect();
        processor.disconnect();
        audioContext.close();
        socket.emit(SocketEventDirection.request, {
          type: SocketEventRequestType.stopTranscription,
        });
      } catch (error) {
        log('error closing audio', error);
      }
    }
  }

  return {
    startRecording,
    stopRecording,
  };
};
